/*
 * `assets` module
 */

export default {
    // -- Splash screen assets, displayed during the 'Preload' state.
    boot: [
        {
            key: 'preloader',
            type: 'atlasJSONHash',
            atlasURL: 'images/' + PARAMS.assetsVersion + '/preloader.json',
            textureURL: 'images/' + PARAMS.assetsVersion + '/preloader.png'
        }
    ],

    // -- General assets, used throughout the game.
    game: [
        {
            key: 'blurredBg',
            type: 'image',
            url: 'images/blurredBg.png'
        }, {
            key: 'backgroundMusic',
            type: 'audio',
            urls: ['audio/music/backgroundMusic.mp3', 'audio/music/backgroundMusic.m4a', 'backgroundMusic.ogg']
        }, {
            key: 'TilePop2',
            type: 'audio',
            urls: ['audio/sfx/TilePop2.mp3', 'audio/sfx/TilePop2.m4a', 'audio/sfx/TilePop2.ogg']
        }, {
            key: 'BaddieGrunt1',
            type: 'audio',
            urls: ['audio/sfx/BaddieGrunt1.mp3', 'audio/sfx/BaddieGrunt1.m4a', 'audio/sfx/BaddieGrunt1.ogg']
        }, {
            key: 'emptyLine',
            type: 'audio',
            urls: ['audio/sfx/emptyLine.mp3', 'audio/sfx/emptyLine.m4a', 'audio/sfx/emptyLine.ogg']
        }, {
            key: 'PowerupPartyBombExplosion1',
            type: 'audio',
            urls: ['audio/sfx/PowerupPartyBombExplosion1.mp3', 'audio/sfx/PowerupPartyBombExplosion1.m4a', 'audio/sfx/PowerupPartyBombExplosion1.ogg']
        }, {
            key: 'bombCharged',
            type: 'audio',
            urls: ['audio/sfx/bombCharged.mp3', 'audio/sfx/bombCharged.m4a', 'audio/sfx/bombCharged.ogg']
        }, {
            key: 'ButtonClick',
            type: 'audio',
            urls: ['audio/sfx/ButtonClick.mp3', 'audio/sfx/ButtonClick.m4a', 'audio/sfx/ButtonClick.ogg']
        }, {
            key: 'Success',
            type: 'audio',
            urls: ['audio/sfx/Success.mp3', 'audio/sfx/Success.m4a', 'audio/sfx/Success.ogg']
        }, {
            key: 'gameOver',
            type: 'audio',
            urls: ['audio/sfx/gameOver.mp3', 'audio/sfx/gameOver.m4a', 'audio/sfx/gameOver.ogg']
        }, {
            key: 'time_15sec',
            type: 'audio',
            urls: ['audio/sfx/time_15sec.mp3', 'audio/sfx/time_15sec.m4a', 'audio/sfx/time_15sec.ogg']
        }, {
            key: 'time_30sec',
            type: 'audio',
            urls: ['audio/sfx/time_30sec.mp3', 'audio/sfx/time_30sec.m4a', 'audio/sfx/time_30sec.ogg']
        }, {
            key: 'words',
            type: 'text',
            url: 'words.txt'
        }, {
            key: 'fontsData',
            type: 'json',
            url: 'data/fontsData.json'
        }, {
            key: 'fontsAll',
            type: 'atlasJSONHash',
            atlasURL: 'images/fontsAll.json',
            textureURL: 'images/fontsAll.png'
        }, {
            'type': 'script',
            'key': 'BlurX',
            'url': 'filters/BlurX.js'
        },
        {
            'type': 'script',
            'key': 'BlurY',
            'url': 'filters/BlurY.js'
        }]
}
